// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TUm5cZg5PdyCb0HMyaPr{display:flex;flex-direction:row;align-items:center;width:calc(100% - 24px);flex-wrap:nowrap;margin:12px 12px}._CVtBClC6jf2gsjsacsw{color:#f47321;font-size:14px;font-family:"UbuntuRegular",Arial,Helvetica,sans-serif}.eTtErj30N0byELmrWqnx{flex:1 1 auto;height:1px;background-color:#f47321;margin-right:12px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"newMessageLine": `TUm5cZg5PdyCb0HMyaPr`,
	"text": `_CVtBClC6jf2gsjsacsw`,
	"line": `eTtErj30N0byELmrWqnx`
};
export default ___CSS_LOADER_EXPORT___;
